import Header from './Header'
import { Link } from 'react-router-dom';
import Faq from './Faq';
import Footer from './Footer';
import { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import ReactMarkdown from 'react-markdown';

function TemplateServizi() {

    const { id } = useParams()
    //const [ser, setSer] = useState([])
    const [pres, setPres] = useState([])
    const getSer = () => {
        fetch(`${document.apiURL}/seopages`, {
            method: 'GET',
            headers: {
                'x-access-token': localStorage.getItem('Token'),
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then(data => {
                setPres(data.map(a => a.title.toLowerCase().replace(/[^a-zA-Z0-9-_]/g, '-') === id ? { text: a.title, sub: a.descr, photo: a.photo } : null).filter(b => b !== null))
                window.scrollTo(0, 0);
            })
    }
    useEffect(() => {
        getSer()
    }, []);

    return (<>

        <Header></Header>
        <div className="main-header">
            <div className="container">
                <div className="flex">
                    {pres && pres.map(a =>
                        <><div className="f1" style={{ alignSelf: 'center' }}>
                            <div className="col sm-mid">
                                <img src={`${process.env.PUBLIC_URL}/img/${a.photo.trim()}`} className="none-web img-ser" />
                                <h2>{a.text}</h2>
                                <span className="blue-line" />
                                <p style={{ width: '90%' }} className="margin">
                                    <ReactMarkdown>{a.sub}</ReactMarkdown>
                                </p>
                                <Link to="/"><button className="button margin-top">Vai alla prenotazione</button></Link>

                            </div>
                        </div>
                            < img src={`${process.env.PUBLIC_URL}/img/${a.photo.trim()}`} className="none-sma img-ser" style={{borderRadius:'16px'}} /></>
                    )}
                </div>
            </div>
        </div>

        {/*   <div className="main-header main-headers">
            <div className="container containers colonna flex-cp servizi">
                <div className="text-center">
                    <h2 align="center">Servizi offerti</h2>
                    <span className="blue-line">

                    </span></div>
                <div style={{ justifyContent: 'space-between' }} className="flex row scrolling-wrapper-flexbox margin">



                    card.map((e) =>
                        <div className="card-pt flex-n">
                            <img src={e.photo} className="img-card-cv" />
                            <div className="text-card-pt">
                                <div>
                                    <h4>{e.text}</h4>
                                    <p className="sub">{e.sub}</p>
                                    <div>
                                    <a style={{ justifyItems: 'flex-end' }} className="link">Prenota una prestazione </a><img style={{width: '15px', transform: 'rotate(-90deg)'}} src={arrow}/></div>
                                </div>
                            </div>
                        </div>
                    ) 
                </div>
            </div>
        </div>



        <div className="main-header">
            <div className="container">
                <div className="flex" style={{padding: '1.5rem'}}>
                    <div className="f1" >
                        <div className="flex row center-con">
                            <h2 className="c">Cerchi un fisioterapista? Chiedi a Futura.</h2>
                            <img src={futura} style={{ width: '30%', height: '60%' }} className="none-web">
                            </img>
                        </div>
                         <div className="col sm-mid">

                            <p style={{ width: '80%' }}>Se un tuo caro ha bisogno di assistenza ma non sai da dove iniziare, i nostri consulenti sono a disposizione per ascoltare le tue esigenze e guidarti verso il percorso assistenziale più adeguato. Ritrova serenità, prenota adesso un colloquio gratuito.
                            </p>
                            <div style={{width: 'fit-content'}}>
                                <button className="button margin-top-min">Vai alla prenotazione</button>
                                <div className="mid">
                                    <p className="margin-top-min">Altrimenti</p></div>
                                <button className="button margin-top-min">Videochiamami</button>
                                <div className="mid">
                                    <p className="margin-top-min">Oppure chiamami al numero</p>
                                    <a href='tel:+3908119312726'>081 193 12 726</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <img src={futura} style={{ width: '30%', height: '60%' }} className="none-sma" />
                </div>
            </div>
        </div>*/}
        <div className="con-min containers colonna flex-cp servizi">
            <div className="text-center">
                <h2 align="center">Domande frequenti</h2>
                <span className="blue-line">
                </span>
            </div>
            <div className="flex colonna">
                <Faq filter={id} />
            </div>
        </div>
        <Footer />
    </>
    );
}


export default TemplateServizi;